/**
 * Conscious alerts badge — AppTopBar (SSE live count via shared client)
 */

import React from 'react';
import { Badge, Button, Tooltip } from 'antd';
import { AlertOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useMenuVisibility } from '../../hooks/ui/useMenuVisibility';
import { useConsciousAlertsSse } from '@frontend/domain-hooks/conscious/useConsciousAlertsSse';

const CONSCIOUS_ALERTS_PATH = '/conscious/alerts';

export function ConsciousAlertsBadge(): React.ReactElement | null {
  const navigate = useNavigate();
  const { canAccessPath } = useMenuVisibility();
  const { alertCount } = useConsciousAlertsSse();

  if (!canAccessPath(CONSCIOUS_ALERTS_PATH)) {
    return null;
  }

  if (alertCount <= 0) {
    return null;
  }

  return (
    <Tooltip title="Conscious 경보">
      <Badge count={alertCount} size="small" offset={[-2, 2]}>
        <Button
          type="text"
          icon={<AlertOutlined />}
          onClick={() => navigate(CONSCIOUS_ALERTS_PATH)}
          aria-label={`Conscious 경보 ${alertCount}건`}
          data-testid="conscious-alerts-badge"
        />
      </Badge>
    </Tooltip>
  );
}

export default ConsciousAlertsBadge;
